<template>
  <div class="row">
    <div class="col-md-12">
      <div class="card">
        <div class="card-body">
          <b-tabs v-model="tab">
            <b-tab :title="$t('edu_programs.edu_programs')" active>
              <div
                class="
                  kt-container kt-container--fluid
                  kt-grid__item kt-grid__item--fluid
                "
              >
                <div class="row">
                  <b-col md="12">
                    <b-card no-body>
                      <b-card-body>
                        <b-row>
                          <b-col cols="12" md="4" class="mb-md-0 mb-2">
                            <select
                              class="form-control form-select"
                              v-model="program_type"
                              @change="changFilter('program_type')"
                            >
                              <option value="">
                                {{ $t("edu_programs.program_type") }}
                              </option>
                              <option
                                :value="item"
                                v-for="item in programType"
                                :key="item"
                              >
                                {{ $t("edu_programs." + item) }}
                              </option>
                            </select>
                          </b-col>

                          <b-col cols="12" md="4" class="mb-md-0 mb-2">
                            <select
                              class="form-control form-select"
                              id="subscriptiontype"
                              v-model="subscriptiontype"
                               @change="changFilter('subscriptiontype')"
                            >
                              <option value="">
                                {{ $t("edu_programs.subscription_types") }}
                              </option>
                              <option order="asc" trans="yes" value="paid">
                                {{ $t("edu_programs.paid") }}
                              </option>
                              <option order="desc" trans="yes" value="free">
                                {{ $t("edu_programs.free") }}
                              </option>
                            </select>
                          </b-col>
                          <b-col cols="12" md="4" class="mb-md-0 mb-2">
                            <select
                              class="form-control form-select"
                              id="sorting"
                              v-model="sorting"
                              @change="changFilter('sorting')"
                            >
                              <option value="">{{ $t("cms.orderby") }}</option>
                              <option value="name|asc">
                                {{ $t("cms.title") }} - {{ $t("cms.asc") }}
                              </option>
                              <option value="name|desc">
                                {{ $t("cms.title") }} - {{ $t("cms.desc") }}
                              </option>

                              <option value="num_of_years|asc">
                                {{
                                  $t("edu_programs.num_of_years") +
                                  " - " +
                                  $t("cms.asc")
                                }}
                              </option>
                              <option value="num_of_years|desc">
                                {{
                                  $t("edu_programs.num_of_years") +
                                  " - " +
                                  $t("cms.desc")
                                }}
                              </option>

                              <option value="h_register_start_date|asc">
                                {{
                                  $t("edu_programs.h_register_start_date") +
                                  " - " +
                                  $t("cms.asc")
                                }}
                              </option>
                              <option value="h_register_start_date|desc">
                                {{
                                  $t("edu_programs.h_register_start_date") +
                                  " - " +
                                  $t("cms.desc")
                                }}
                              </option>
                              <option value="g_register_start_date|asc">
                                {{
                                  $t("edu_programs.g_register_start_date") +
                                  " - " +
                                  $t("cms.asc")
                                }}
                              </option>
                              <option value="g_register_start_date|desc">
                                {{
                                  $t("edu_programs.g_register_start_date") +
                                  " - " +
                                  $t("cms.desc")
                                }}
                              </option>
                            </select>
                          </b-col>
                        </b-row>
                      </b-card-body>
                    </b-card>
                  </b-col>
                </div>
                <!-- end of row -->
                <div class="row">
                  <transition name="fade" mode="out-in">
                    <div v-if="!load" class="col-md-12">
                      <div
                        v-if="eduPrograms.length"
                        id="nav-group"
                        class="tab-pane fade show active pt-3"
                        role="tabpanel"
                        aria-labelledby="nav-group-tab"
                      >
                        <b-row>
                          <b-col
                            md="4"
                            v-for="eduProgram in eduPrograms"
                            :key="eduProgram.id"
                          >
                            <!--begin::Container-->
                            <b-card no-body class="card-developer-meetup">
                              <div
                                class="bg-light-primary rounded-top text-center"
                              >
                                <b-img
                                  :src="getImageUrl(eduProgram.icon_path)"
                                  alt="Meeting Pic"
                                  height="170"
                                />
                              </div>
                              <b-card-body>
                                <!-- metting header -->
                                <div
                                  class="
                                    meetup-header
                                    d-flex
                                    align-items-center
                                  "
                                >
                                  <div class="meetup-day">
                                    <h6 class="mb-0">THU</h6>
                                    <h3 class="mb-0">24</h3>
                                  </div>
                                  <div class="my-auto">
                                    <b-card-title class="mb-25">
                                      {{ eduProgram.name }}
                                    </b-card-title>
                                    <b-card-text
                                      class="mb-0"
                                      v-if="eduProgram.edu_season"
                                    >
                                      <b-badge
                                        variant="success"
                                        class="badge-glow"
                                      >
                                        {{ eduProgram.edu_season.name }}
                                      </b-badge>
                                      --
                                      <b-badge
                                        variant="info"
                                        class="badge-glow"
                                      >
                                        {{ eduProgram.program_list.name }}
                                      </b-badge>
                                    </b-card-text>
                                  </div>
                                </div>
                                <hr />
                                <!--/ metting header -->

                                <!-- media -->
                                <b-media no-body>
                                  <b-media-aside class="mr-1">
                                    <b-avatar
                                      rounded
                                      variant="light-primary"
                                      size="34"
                                    >
                                      <feather-icon
                                        icon="CalendarIcon"
                                        size="18"
                                      />
                                    </b-avatar>
                                  </b-media-aside>
                                  <b-media-body>
                                    <h6 class="mb-0">يبدأ في</h6>
                                    <small>
                                      {{ eduProgram.g_study_start_date }}</small
                                    >
                                  </b-media-body>
                                </b-media>
                                <b-media no-body>
                                  <b-media-aside class="mr-1">
                                    <b-avatar
                                      rounded
                                      variant="light-primary"
                                      size="34"
                                    >
                                      <feather-icon
                                        icon="CalendarIcon"
                                        size="18"
                                      />
                                    </b-avatar>
                                  </b-media-aside>
                                  <b-media-body>
                                    <h6 class="mb-0">ينتهي في</h6>
                                    <small>
                                      {{ eduProgram.g_study_end_date }}
                                    </small>
                                  </b-media-body>
                                </b-media>

                                <b-row>
                                  <b-col md="6">
                                    <!-- avatar group -->
                                    <b-avatar-group
                                      class="mt-2 pt-50"
                                      size="33"
                                    >
                                      <b-avatar
                                        v-for="avatar in eduProgram.students"
                                        :key="avatar.avatar"
                                        v-b-tooltip.hover.bottom="
                                          avatar.full_name
                                        "
                                        :src="avatar.profile_image_path"
                                        class="pull-up"
                                      />
                                      <!-- <h6
                            class="align-self-center cursor-pointer ml-1 mb-0"
                          >
                            
                          </h6> -->
                                    </b-avatar-group>
                                  </b-col>
                                  <b-col md="6" class="mt-2 pt-50" size="33">
                                    <b-row>
                                      <b-col lg="12" class="text-center">
                                        <b-button
                                          variant="relief-info"
                                          :to="{
                                            name: 'EduProgramDetails',
                                            params: {
                                              eduProgramId: eduProgram.id,
                                            },
                                          }"
                                        >
                                          تفاصيل البرنامج
                                        </b-button>
                                      </b-col>
                                    </b-row>
                                    <br />
                                  </b-col>
                                </b-row>
                                <hr />
                                <b-row v-if="haveStudent(eduProgram.students)">
                                  <b-col lg="12" class="text-center">
                                    <b-button
                                      class="col-lg-10"
                                      variant="relief-primary"
                                      v-if="
                                        eduProgram.subscription_type == 'paid'
                                      "
                                      @click="subscribe(eduProgram.id)"
                                    >
                                      الاشتراك بالبرنامج -
                                      {{ eduProgram.subscription_fees }} ريال
                                      <span v-if="eduProgram.can_installment">
                                        (امكانية التقسيط)</span
                                      >
                                    </b-button>
                                    <b-button
                                      class="col-lg-10"
                                      variant="relief-primary"
                                      v-else
                                      @click="subscribionFree(eduProgram.id)"
                                    >
                                      الاشتراك بالبرنامج - مجاني
                                    </b-button>
                                  </b-col>
                                </b-row>
                                <b-row v-else>
                                  <b-col lg="12" class="text-center">
                                    <b-button
                                      variant="relief-success "
                                      disabled
                                      class="col-lg-10"
                                    >
                                      تم ارسال الطلب</b-button
                                    >
                                  </b-col>
                                </b-row>
                              </b-card-body>
                            </b-card>
                          </b-col>
                        </b-row>
                      </div>
                      <!-- /.tab-pane -->
                      <div
                        v-else
                        id="nav-group"
                        class="tab-pane fade show active pt-3"
                        role="tabpanel"
                        aria-labelledby="nav-group-tab"
                      >
                        <h2>{{ $t("edu_programs.no_edu_programs") }}</h2>
                      </div>
                      <!-- /.tab-pane -->
                    </div>
                  </transition>
                </div>
              </div>
            </b-tab>
            <b-tab
              @click="newItem = {}"
              :title="$t('edu_programs.course_programs')"
            >
              <div class="row">
                <transition name="fade" mode="out-in">
                  <div v-if="!load" class="col-md-12">
                    <div
                      v-if="eduPrograms.length"
                      id="nav-group"
                      class="tab-pane fade show active pt-3"
                      role="tabpanel"
                      aria-labelledby="nav-group-tab"
                    >
                      <b-row>
                        <b-col
                          md="4"
                          v-for="eduProgram in courses"
                          :key="eduProgram.id"
                        >
                          <!--begin::Container-->
                          <b-card no-body class="card-developer-meetup">
                            <div
                              class="bg-light-primary rounded-top text-center"
                            >
                              <b-img
                                :src="getImageUrl(eduProgram.icon_path)"
                                alt="Meeting Pic"
                                height="170"
                              />
                            </div>
                            <b-card-body>
                              <!-- metting header -->
                              <div
                                class="meetup-header d-flex align-items-center"
                              >
                                <div class="meetup-day">
                                  <h6 class="mb-0">THU</h6>
                                  <h3 class="mb-0">24</h3>
                                </div>
                                <div class="my-auto">
                                  <b-card-title class="mb-25">
                                    {{ eduProgram.name }}
                                  </b-card-title>
                                  <b-card-text
                                    class="mb-0"
                                    v-if="eduProgram.edu_season"
                                  >
                                    <b-badge
                                      variant="success"
                                      class="badge-glow"
                                    >
                                      {{ eduProgram.edu_season.name }}
                                    </b-badge>
                                    --
                                    <b-badge variant="info" class="badge-glow">
                                      {{ eduProgram.program_list.name }}
                                    </b-badge>
                                  </b-card-text>
                                </div>
                              </div>
                              <hr />
                              <!--/ metting header -->

                              <!-- media -->
                              <b-media no-body>
                                <b-media-aside class="mr-1">
                                  <b-avatar
                                    rounded
                                    variant="light-primary"
                                    size="34"
                                  >
                                    <feather-icon
                                      icon="CalendarIcon"
                                      size="18"
                                    />
                                  </b-avatar>
                                </b-media-aside>
                                <b-media-body>
                                  <h6 class="mb-0">يبدأ في</h6>
                                  <small>
                                    {{ eduProgram.g_study_start_date }}</small
                                  >
                                </b-media-body>
                              </b-media>
                              <b-media no-body>
                                <b-media-aside class="mr-1">
                                  <b-avatar
                                    rounded
                                    variant="light-primary"
                                    size="34"
                                  >
                                    <feather-icon
                                      icon="CalendarIcon"
                                      size="18"
                                    />
                                  </b-avatar>
                                </b-media-aside>
                                <b-media-body>
                                  <h6 class="mb-0">ينتهي في</h6>
                                  <small>
                                    {{ eduProgram.g_study_end_date }}
                                  </small>
                                </b-media-body>
                              </b-media>

                              <b-row>
                                <b-col md="6">
                                  <!-- avatar group -->
                                  <b-avatar-group class="mt-2 pt-50" size="33">
                                    <b-avatar
                                      v-for="avatar in eduProgram.students"
                                      :key="avatar.avatar"
                                      v-b-tooltip.hover.bottom="
                                        avatar.full_name
                                      "
                                      :src="avatar.profile_image_path"
                                      class="pull-up"
                                    />
                                    <!-- <h6
                            class="align-self-center cursor-pointer ml-1 mb-0"
                          >
                            
                          </h6> -->
                                  </b-avatar-group>
                                </b-col>
                                <b-col md="6" class="mt-2 pt-50" size="33">
                                  <b-row>
                                    <b-col lg="12" class="text-center">
                                      <b-button
                                        variant="relief-info"
                                        :to="{
                                          name: 'EduProgramDetails',
                                          params: {
                                            eduProgramId: eduProgram.id,
                                          },
                                        }"
                                      >
                                        تفاصيل البرنامج
                                      </b-button>
                                    </b-col>
                                  </b-row>
                                  <br />
                                </b-col>
                              </b-row>
                              <hr />
                              <b-row v-if="haveStudent(eduProgram.students)">
                                <b-col lg="12" class="text-center">
                                  <b-button
                                    class="col-lg-10"
                                    variant="relief-primary"
                                    v-if="
                                      eduProgram.subscription_type == 'paid'
                                    "
                                    @click="subscribe(eduProgram.id)"
                                  >
                                    الاشتراك بالبرنامج -
                                    {{ eduProgram.subscription_fees }} ريال
                                    <span v-if="eduProgram.can_installment">
                                      (امكانية التقسيط)</span
                                    >
                                  </b-button>
                                  <b-button
                                    class="col-lg-10"
                                    variant="relief-primary"
                                    v-else
                                    @click="subscribionFree(eduProgram.id)"
                                  >
                                    الاشتراك بالبرنامج - مجاني
                                  </b-button>
                                </b-col>
                              </b-row>
                              <b-row v-else>
                                <b-col lg="12" class="text-center">
                                  <b-button
                                    variant="relief-success "
                                    disabled
                                    class="col-lg-10"
                                  >
                                    تم ارسال الطلب</b-button
                                  >
                                </b-col>
                              </b-row>
                            </b-card-body>
                          </b-card>
                        </b-col>
                      </b-row>
                    </div>
                    <!-- /.tab-pane -->
                    <div
                      v-else
                      id="nav-group"
                      class="tab-pane fade show active pt-3"
                      role="tabpanel"
                      aria-labelledby="nav-group-tab"
                    >
                      <h2>{{ $t("edu_programs.no_edu_programs") }}</h2>
                    </div>
                    <!-- /.tab-pane -->
                  </div>
                </transition>
              </div>
            </b-tab>
          </b-tabs>
        </div>
        <!-- end of card body -->
      </div>
      <!-- end of card -->
    </div>
    <!-- end of col -->
    <!-- modal vertical center -->
    <b-modal
      id="modal-center"
      centered
      title="شكراً جزيلاً"
      ok-only
      ok-title="قبول"
    >
      <b-card-text>
        شكراً جزيلاً ، تم تقديم نموذج التقديم الخاص بك للإشتراك في برنامج
        الدراسة وسيتم إرسال رسالة تأكيدية في حالة قبول الطالب الخاص بك.
      </b-card-text>
    </b-modal>
  </div>
</template>

<script>
import Controller from "../../../Controllers/EduProgramsController";
import config from "@/config/config";
import vSelect from "vue-select";
import Auth from "@/Apis/Auth";
let ctr = new Controller();
export default {
  name: "UnSubscribed",
  components: {
    vSelect,
  },
  data() {
    return {
      eduPrograms: {},
      load: false,
      sorting: "",
      subscriptiontype: "",
      program_type: "",
      programType: [
        "systematic",
        "non_systematic",
        "non_arabic",
        "women",
        "children",
        "bhd",
        "quran",
      ],
      courses: [],
    };
  },
  async created() {
    this.getData();
  },
  methods: {
    async getData(params) {
      this.load = true;
      let edu = await ctr.UnSubscribed(params);

      this.eduPrograms = edu.filter((a) => a.is_course == 0);
      this.courses = edu.filter((a) => a.is_course == 1);
      this.load = false;
    },
    changFilter(type) {
      // sorting:"",
      // subscriptiontype:"",
      // program_type:"",
      var filter = [];
      if (this.sorting !== "") {
        filter.push(`sort|${this.sorting}`);
      }
      if (this.subscriptiontype !== "") {
        filter.push(`subscription_type|${this.subscriptiontype}`);
      }
      if (this.program_type !== "") {
        filter.push(`program_type|${this.program_type}`);
      }
      this.getData({ filter });
    },
    haveStudent(students) {
      return !students.some((e) => e.id === Auth.USER.id);
    },
    editItem(data) {
      this.form = true;
      this.newItem = data.item;
    },
    getImageUrl(image_path) {
      return config.serverUrl + image_path;
    },
    subscribionFree: async function (id) {
      let res = await ctr.subscribionFree(id);
      if (res.success) {
        this.load = true;
        this.$bvModal.show("modal-center");
        this.eduPrograms = await ctr.UnSubscribed();
        this.load = false;
      }
    },
    subscribe: async function (id) {
      this.$router.push({ name: "InvoicePreview", params: { id } });
    },
  },
};
</script>
<style   scoped>
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}
</style>
<style lang="scss">
@import "@core/scss/vue/libs/vue-select.scss";
</style>
